import { useEffect, useState, useTransition } from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import cameraIcon from '../../../assets/img/icons/camera.svg';
import removeAssignee from '../../../assets/img/icons/remove_assignee.svg';
import uploadIcon from '../../../assets/img/icons/upload.svg';
import { createNotification } from '../../../modules/notificationManager';
import { CommonImage, CommonText } from '../../../styledComponents/common';
import { RoundImageCross } from '../../../styledComponents/createProject';
import {
  CameraIcon,
  DropZoneContainer,
  NoImageContainer,
  UpdateImageHoverDiv,
  UploadImageDiv,
} from '../../UserProfile/profileStyles';

const thumbsContainer = {
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  objectFit: 'cover',
  objectPosition: 'center',
};

const dropZoneCss = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const dropZoneCssNoBorder = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ImageUpload = props => {
  const [warningMsg, setwarningMsg] = useState('');
  const [imageState, setimageState] = useState(null);
  const [filesState, setfilesState] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    handleSave();
  }, [filesState]);

  const onDrop = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      createNotification('error', 'Wrong image format', 3000);
    } else if (Number(accepted[0].size) > 2048000) {
      createNotification('error', 'Image max size is 2MB', 3000);
    } else {
      props.addFile(accepted);
      setwarningMsg('');
      var blobPromise = new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(accepted[0]);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
      blobPromise.then(value => {
        setfilesState(accepted[0]);
        let fileTemp = accepted[0];
        fileTemp.base64 = value;
        setimageState(value);
        setfilesState(fileTemp);
      });
    }
  };

  const handleSave = () => {
    const { handleSave } = props;
    let payload = {};
    const files = filesState;
    if (files) {
      payload.image = files.base64;
      handleSave(payload);
    }
  };
  const imageRemove = () => {
    alert('image remove');
  };

  return (
    <DropZoneContainer>
      <Dropzone
        style={
          filesState.base64 || props.files ? dropZoneCssNoBorder : dropZoneCss
        }
        multiple={false}
        accept="image/*"
        onDrop={(accepted, rejected) => onDrop(accepted, rejected)}
      >
        {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
          // if (isDragReject) return 'Please submit a valid file';
          if (props.files) {
            return (
              <UploadImageDiv height="50px">
                <img
                  style={thumbsContainer}
                  src={filesState.base64 ? filesState.base64 : props.files}
                  alt=""
                />
                <UpdateImageHoverDiv>
                  <CommonImage src={uploadIcon} alt="" size="24px" />
                  <CommonText fontSize="14px" margin="0">
                    {t('click_or_drop_here_to_upload')}
                  </CommonText>
                  <CommonText fontSize="12px" margin="0">
                    {t('max_10_md_files_are_allowed')}
                  </CommonText>
                </UpdateImageHoverDiv>
              </UploadImageDiv>
            );
          } else {
            return (
              <NoImageContainer height="50px">
                <CommonImage src={uploadIcon} alt="" size="24px" />
                <CommonText fontSize="14px" margin="0">
                  {t('click_or_drop_here_to_upload')}
                </CommonText>
                <CommonText fontSize="12px" margin="0">
                  {t('max_10_md_files_are_allowed')}
                </CommonText>
              </NoImageContainer>
            );
          }
        }}
      </Dropzone>
    </DropZoneContainer>
  );
};
export default ImageUpload;
